import React, { useMemo } from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

/**
 * @typedef {Object} Dataset
 * @property {string} color - The color of the legend item
 * @property {string} label - The label of the legend item
 */

/**
 * @param {Object} props
 * @param {Dataset[]} props.data - The legend data
 * @param {string} props.className - Additional classNames for the legend
 * @param {(dataset: Dataset) => string} props.formatLabel - Function to format the legend label
 */
export default function Legend({
  data = [],
  className = '',
  formatLabel = () => ''
}) {
  const items = useMemo(() => {
    return data.map((dataset, index) => {
      const formattedLabel = formatLabel(dataset) || dataset.label;
      return (
        <li key={index} className={styles.legend}>
          <div style={{ backgroundColor: dataset.color }} />
          <div>{formattedLabel}</div>
        </li>
      );
    });
  }, [data, formatLabel]);

  return <ul className={cn(styles.legends, className)}>{items}</ul>;
}
